<template>
  <div id="driver-manager">
    <section class="section">
      <card-component
        class="has-table is-fullwidth"
        title="Driver List"
        icon="video-input-component"
      >
        <template #headerRight>
          <router-link to="driver/create">
            <b-button
              v-if="hasPermission('POST')"
              type="is-primary"
              icon-left="plus"
              size="is-small"
            >
              New Driver
            </b-button>
          </router-link>
        </template>
        <fl-table
          is-paginated
          namespace="driver"
          ref="table"
          title-key="name"
          :columns="driverColumns"
          :has-delete="hasPermission('DELETE')"
          :has-update="hasPermission('PUT')"
          :service="service"
        >
          <template #actions="{ row }">
            <a
              v-if="hasPermission('POST')"
              target="_blank"
              :href="getExportDriverURL(row)"
            >
              <b-button class="button is-small" icon-left="file">
                Export
              </b-button>
            </a>
          </template>
        </fl-table>
      </card-component>
    </section>
  </div>
</template>

<script>
import { read as readDriver, del as deleteDriver } from '@/api/driver'
import FlTable from '@/components/table/FlTable'

export default {
  name: 'ReadDriver',
  components: { FlTable },
  data() {
    const driverColumns = [
      {
        label: 'Name',
        key: 'name'
      }
    ]

    return {
      driverColumns,
      service: {
        read: readDriver,
        delete: deleteDriver
      },
      importForm: {
        file: null,
        isLoading: false
      }
    }
  },
  methods: {
    hasPermission(method) {
      return this.$store.getters['auth/hasPermission']('DRIVER', method)
    },
    getExportDriverURL(driver) {
      return `${process.env.VUE_APP_BASE_URL}/driver/export/${driver.id}`
    }
  }
}
</script>
